/**
 * RENDERING: GhostRenderer
 * Rendering dei fantasmi con tutti i modi
 */

import { Ghost } from '../types/GameTypes'
import { COLORS } from '../types/GameConstants'

export class GhostRenderer {
  static render(
    ctx: CanvasRenderingContext2D,
    ghosts: Ghost[],
    frightenedTimer: number
  ) {
    ghosts.forEach(ghost => {
      ctx.save()
      
      if (ghost.mode === 'frightened') {
        ctx.fillStyle = frightenedTimer < 2000 && Math.floor(frightenedTimer / 200) % 2 
          ? COLORS.FRIGHTENED_FLASH 
          : COLORS.FRIGHTENED
      } else if (ghost.mode === 'eaten') {
        // Draw only eyes when eaten
        this.renderEyes(ctx, ghost)
        ctx.restore()
        return
      } else {
        ctx.fillStyle = ghost.color
      }
      
      // Ghost body
      this.renderGhostBody(ctx, ghost)
      
      // Eyes
      if (ghost.mode !== 'frightened') {
        this.renderEyes(ctx, ghost)
      }
      
      ctx.restore()
    })
  }

  private static renderGhostBody(ctx: CanvasRenderingContext2D, ghost: Ghost) {
    // 💀 CREEPER-FANTASMA DESIGN
    const size = 10
    const x = ghost.x - size/2
    const y = ghost.y - size
    
    // Corpo principale (forma creeper pixelata)
    ctx.fillRect(x, y, size, size * 1.5)
    
    // Pattern creeper sul corpo
    ctx.fillStyle = ghost.mode === 'frightened' ? '#000000' : '#000000'
    
    // Faccia creeper pattern
    // Occhi
    ctx.fillRect(x + 2, y + 2, 2, 2)
    ctx.fillRect(x + 6, y + 2, 2, 2)
    
    // Naso/bocca creeper
    ctx.fillRect(x + 4, y + 5, 2, 1)
    ctx.fillRect(x + 3, y + 6, 1, 2)
    ctx.fillRect(x + 6, y + 6, 1, 2)
    ctx.fillRect(x + 2, y + 8, 2, 1)
    ctx.fillRect(x + 6, y + 8, 2, 1)
    
    // Effetto "pixelato" sui bordi
    ctx.fillStyle = ghost.color
    ctx.fillRect(x - 1, y + 3, 1, 4)
    ctx.fillRect(x + size, y + 3, 1, 4)
    
    // Gambe creeper (piccole)
    ctx.fillRect(x + 1, y + size * 1.5, 2, 3)
    ctx.fillRect(x + 7, y + size * 1.5, 2, 3)
    
    // Effetto "glow" se in modalità chase
    if (ghost.mode === 'chase') {
      ctx.shadowColor = ghost.color
      ctx.shadowBlur = 8
      ctx.fillStyle = ghost.color
      ctx.fillRect(x, y, size, size * 1.5)
      ctx.shadowBlur = 0
    }
  }

  private static renderEyes(ctx: CanvasRenderingContext2D, ghost: Ghost) {
    // White eyes
    ctx.fillStyle = '#FFFFFF'
    ctx.beginPath()
    ctx.arc(ghost.x - 3, ghost.y - 3, ghost.mode === 'eaten' ? 4 : 3, 0, Math.PI * 2)
    ctx.arc(ghost.x + 3, ghost.y - 3, ghost.mode === 'eaten' ? 4 : 3, 0, Math.PI * 2)
    ctx.fill()
    
    if (ghost.mode !== 'eaten') {
      // Black pupils
      ctx.fillStyle = '#000'
      ctx.beginPath()
      const pupilOffsetX = ghost.direction === 'left' ? -1 : ghost.direction === 'right' ? 1 : 0
      const pupilOffsetY = ghost.direction === 'up' ? -1 : ghost.direction === 'down' ? 1 : 0
      
      ctx.arc(ghost.x - 3 + pupilOffsetX, ghost.y - 3 + pupilOffsetY, 1.5, 0, Math.PI * 2)
      ctx.arc(ghost.x + 3 + pupilOffsetX, ghost.y - 3 + pupilOffsetY, 1.5, 0, Math.PI * 2)
      ctx.fill()
    } else {
      // Black pupils for eaten ghost
      ctx.fillStyle = '#000'
      ctx.beginPath()
      ctx.arc(ghost.x - 3, ghost.y - 3, 2, 0, Math.PI * 2)
      ctx.arc(ghost.x + 3, ghost.y - 3, 2, 0, Math.PI * 2)
      ctx.fill()
    }
  }
}
